import config from '../../../../config/config';
import { CompaniesApi, Configuration } from '../../../../generate/api';
import { store } from '../../../../redux/store';

export const companiesApi = new CompaniesApi(
    new Configuration({
        basePath: config.api.baseUrl,
        accessToken: () => {
            return store.getState().keycloak.token as string;
        },
    }),
);
